/* eslint-disable react/jsx-key */
import { Box, Copy, IconWrapper as DsrIconWrapper, Icon, Optional } from '@honda-canada/design-system-react';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import BapAlertModalContent from './BapAlertModalContent';
import CommonModal from '../CommonModal/CommonModal';
import themeStyles from './BapSummaryAlert.styles';
import useSummaryAlertCtaColors from './useSummaryAlertCtaColors';
const SummaryAlertWrapper = themeStyles.apply(Box, 'SummaryAlertWrapper');
const SummaryAlertCopy = themeStyles.apply(Copy, 'SummaryAlertCopy');
const SeeChangesCta = themeStyles.apply(Box, 'SeeChangesCta');
const IconWrapper = themeStyles.apply(DsrIconWrapper, 'IconWrapper');
const TextCtaWrapper = themeStyles.apply(Box, 'TextCtaWrapper');
const BapSummaryAlert = ({ isPriceAlert, buildItems }) => {
    const { t } = useTranslation();
    const [showModal, setShowModal] = useState(false);
    const ctaColors = useSummaryAlertCtaColors();
    const priceChangeText = t('Pages.Bap.priceChangeAlertText');
    const configChangeText = t('Pages.Bap.configChangeAlertText');
    const seeChangesText = t('Pages.Bap.seeChangesButton');
    const configChangeModalHeading = t('Pages.Bap.configChangeModalHeading');
    const changedItems = buildItems;
    return (React.createElement(React.Fragment, null,
        React.createElement(SummaryAlertWrapper, { "data-testid": isPriceAlert ? 'cy-summary-alert-price' : 'cy-summary-alert-config' },
            React.createElement(Box, { display: "flex", "data-testid": "cy-summary_alert", width: "100%" },
                React.createElement(IconWrapper, { size: "xss", "data-testid": "cy-summary_alert_icon" },
                    React.createElement(Icon, { mr: "s", name: "warning", filled: true })),
                React.createElement(TextCtaWrapper, null,
                    React.createElement(SummaryAlertCopy, { "data-testid": "cy-summary_alert_copy", size: "extraSmall" }, isPriceAlert ? priceChangeText : configChangeText),
                    React.createElement(Optional, { when: !isPriceAlert },
                        React.createElement(SeeChangesCta, { "data-testid": "cy-config_change_alert_cta", onClick: () => setShowModal(true) },
                            React.createElement(SummaryAlertCopy, { size: "backToTop", color: ctaColors.text }, seeChangesText),
                            React.createElement(Icon, { name: "arrowRight", ml: "xs", mr: "s", color: ctaColors.icon })))))),
        React.createElement(CommonModal, { handleCloseModal: () => setShowModal(false), showModal: showModal, dataTestId: "cy-ConfigurationChangeModal", title: configChangeModalHeading },
            React.createElement(BapAlertModalContent, { changedItems: changedItems }))));
};
export default BapSummaryAlert;
